// // Use $ instead of jQuery without replacing global $
(function ($) {

  $(document).ready(function () {
    limit_lines('.latest-news .slider-wrap .slider .item .content p', 3);
    var latest_image = $('body .latest-news .slider-wrap .slider .item .bg-img img');
    objectFitImages(latest_image);

    // limit_lines('body .latest-news .slider-wrap .slider .item .content p', 2);
    setTimeout(function () {
      $('body .latest-news .slider-wrap .slider .item .content p').matchHeight({byRow: 0});
    },500);

    var item_length = $('body .latest-news .slider-wrap .slider .item').length;
    if(item_length == 0) {
      $('body .latest-news').addClass('no-item');
    }
  });

  $(window).on("load", function () {
    $('.latest-news .slider-wrap').css({"opacity":1});

   var slider2 = $('.latest-news .slider-wrap .slider').slick({
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      speed: 500,
      focusOnSelect: false,
      fade: false,
      infinite: false,
      draggable: false,
      dots: false,
      prevArrow: $('.latest-news .slide-nav .slide-prev'),
      nextArrow: $('.latest-news .slide-nav .slide-next'),
     responsive: [
       {
         breakpoint: 992,
         settings: {
           // infinite: true,
         }
       },
       {
         breakpoint: 768,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           // infinite: true,
         }
       }
     ]
    });

    $('.latest-news').css({"opacity":1});
  });

  function setSlider() {
    if ($('.latest-news .container').length > 0) {
      var offsetLeft = $('.latest-news .container').offset().left;
      var left_margin = offsetLeft + 195;
      $('body .latest-news .slider-wrap').css({"margin-left": left_margin + "px"});
    }
  }

  $(window).on("resize", function () {
    setSlider();
    $('.latest-news .slide-nav').addClass('clicked');
    limit_lines('.latest-news .slider-wrap .slider .item .content p', 3);
  }).resize();

  $(document).on("click touchstart tap",'.latest-news .slide-nav .slide-prev, .latest-news .slide-nav .slide-next', function () {
    $('.latest-news .slide-nav').removeClass('clicked');
    var windowWidth = $(window).width();
    var top_space = $("header").height();
    setTimeout(function () {
      if (windowWidth < 768) {
        var content = $('body .latest-news');
        // console.log($(content).offset().top);
        $('html, body').animate({
          'scrollTop': $(content).offset().top - top_space
        }, 800, 'swing');
      }
    }, 100);
  });

})(jQuery);